import request from '@/utils/request'

// 获取实验用房巡课列表
export function getVideoTourList (params) {
  return request({
    url: "/portal/camera/get-round-list",
    method: "get",
    params
  })
}

// 获取实验用房巡课视频
export function getPatrolVideo (params) {
  return request({
    url: "/portal/camera/patrol-video",
    method: "get",
    params
  })
}